<h4>Κωδικάριθμος αιτήματος</h4>
<div class="qrlabel">
    <div class="qrcode">
        <ng-content select=".qrcode-value"></ng-content>
    </div>
    <div class="qrimageplaceholder">
        <!-- <ng-content select=".qrimage"> </ng-content> -->
        <qrcode [qrdata]="qrData" [width]="50" [errorCorrectionLevel]="'L'" [elementType]="'img'" [cssClass]="'image'"></qrcode>
    </div>
</div>

